import { render, staticRenderFns } from "./AthleteKanban.vue?vue&type=template&id=fbe6e332&scoped=true"
import script from "./AthleteKanban.vue?vue&type=script&lang=js"
export * from "./AthleteKanban.vue?vue&type=script&lang=js"
import style0 from "./AthleteKanban.vue?vue&type=style&index=0&id=fbe6e332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe6e332",
  null
  
)

export default component.exports